<template>
  <div class="wx-popup-component">
    <div class="title">{{ currentCommunity.title }}</div>
    <div class="content">{{ currentCommunity.content }}</div>
    <div class="wx-message-img">
      <img v-if="communityInfo" :src="communityInfo.qrcode" alt="" />
      <img v-else :src="qc_code_url" alt="" />
    </div>
    <div class="tips">
      <span>{{ currentCommunity.desc }}</span>
    </div>
    <div class="footer" v-if="currentCommunity.btnText">
      <div class="footer-btn" @click="openCommunity">
        {{ currentCommunity.btnText }}
      </div>
    </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';
import { wechatJSConfig, miniSchemeUrl } from '@/utils/common';

export default {
  props: {
    communityInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      qc_code_url: 'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/tencentQrcode.png',
      textConfig: {
        '2-1-1': {
          // 微信-群-保存二维码
          app: {
            title: '加入备考群',
            content: '领取学习资料和更多小伙伴一起备考',
            desc: '请长按上方二维码保存图片，并在微信扫一扫中添加微信群',
            btnText: '保存二维码，去微信扫码',
            click: () => {
              this.saveImg();
            },
          },
          web: {
            title: '加入备考群',
            content: '领取学习资料和更多小伙伴一起备考',
            desc: '请长按上方二维码保存图片，并在微信扫一扫中添加微信群',
            btnText: '截屏保存二维码，去微信扫码',
            click: () => {
              this.saveImg();
            },
          },
          mini: {
            title: '加入备考群',
            content: '领取学习资料和更多小伙伴一起备考',
            desc: '请长按上方二维码，添加微信群',
            btnText: '',
          },
        },
        '2-1-3': {
          // 微信-群-跳转小程序
          app: {
            title: '加入备考群',
            content: '领取学习资料和更多小伙伴一起备考',
            desc: '点击下方按钮，立即添加',
            btnText: '前往微信添加',
            click: () => {
              this.openMiniBtn();
            },
          },
          web: {
            title: '加入备考群',
            content: '领取学习资料和更多小伙伴一起备考',
            desc: '点击下方按钮，立即添加',
            btnText: '前往微信添加',
            click: () => {
              this.openMiniBtn();
            },
          },
          mini: {
            title: '加入备考群',
            content: '领取学习资料和更多小伙伴一起备考',
            desc: '请长按上方二维码，添加微信群',
            btnText: '',
          },
        },
        '2-2-1': {
          // 微信-个人-保存二维码
          app: {
            title: '助教老师',
            content: '添加助教老师，获得更多课程资料及个性化服务',
            desc: '请长按上方二维码保存图片，并在微信扫一扫中添加微信号',
            btnText: '保存二维码，去微信扫码',
            click: () => {
              this.saveImg();
            },
          },
          web: {
            title: '助教老师',
            content: '添加助教老师，获得更多课程资料及个性化服务',
            desc: '请长按上方二维码保存图片，并在微信扫一扫中添加微信号',
            btnText: '截屏保存二维码，去微信扫码',
            click: () => {
              this.saveImg();
            },
          },
          mini: {
            title: '助教老师',
            content: '添加助教老师，获得更多课程资料及个性化服务',
            desc: '请长按上方二维码，添加微信号',
            btnText: '',
          },
        },

        '2-2-3': {
          // 微信-个人-跳转小程序
          app: {
            title: '助教老师',
            content: '添加助教老师，获得更多课程资料及个性化服务',
            desc: '点击下方按钮，立即添加',
            btnText: '前往微信添加',
            click: () => {
              this.openMiniBtn();
            },
          },
          web: {
            title: '助教老师',
            content: '添加助教老师，获得更多课程资料及个性化服务',
            desc: '点击下方按钮，立即添加',
            btnText: '前往微信添加',
            click: () => {
              this.openMiniBtn();
            },
          },
          mini: {
            title: '助教老师',
            content: '添加助教老师，获得更多课程资料及个性化服务',
            desc: '请长按上方二维码，添加微信群',
            btnText: '',
          },
        },
        account: {
          app: {
            title: '关注服务号',
            content: '关注微信服务号，不错过任何一条重要消息',
            desc: '点击按钮，立即关注服务号',
            btnText: '前往微信添加',
            click: () => {
              this.openMiniBtn();
            },
          },
          web: {
            title: '关注服务号',
            content: '关注微信服务号，不错过任何一条重要消息',
            desc: '点击按钮，立即关注服务号',
            btnText: '前往微信添加',
            click: () => {
              this.openMiniBtn();
            },
          },
          mini: {
            title: '关注服务号',
            content: '关注微信服务号，不错过任何一条重要消息',
            desc: '请长按上方二维码，添加服务号',
            btnText: '',
          },
        },
      },
      isWechatBrowser: /MicroMessenger/i.test(navigator.userAgent),
      currentCommunity: {},
    };
  },
  watch: {},
  async mounted() {
    wechatJSConfig();

    // 新版本
    const { platform, accountType, groupEntryMode, communityId } = this.communityInfo || {};
    let currentCommunity = '';
    if (communityId && platform === 2) {
      currentCommunity = this.textConfig[`${platform}-${accountType}-${groupEntryMode}`];
    }
    if (!communityId) {
      currentCommunity = this.textConfig[`account`];
    }
    this.currentCommunity = this.$root.isApp
      ? currentCommunity['app']
      : this.$root.miniprogram||this.isWechatBrowser
      ? currentCommunity['mini']
      : currentCommunity['web'];

  },
  methods: {
    saveImg() {
      if (this.$root.$data.isApp) {
        let url = this.communityInfo?.qrcode;
        this.$sendToApp('addWechatGroup', { QRCodeUrl: url }, false);
      } else {
        this.$toast('正在打开微信');
        setTimeout(() => {
          window.location.href = 'weixin://';
        }, 500);
      }
    },
    openCommunity() {
      this.currentCommunity['click']();
    },
    // 打开微信小程序并打开公众号文章界面
    async openMiniBtn() {
      const { communityId } = this.communityInfo || {};
      if (this.$root.$data.isApp) {
        this.$sendToApp('goWechatProject', {
          userName: 'gh_5fb96ed24012',
          path: `/subPackages/codePage/codePage?communityId=${communityId || ''}`,
        });
      } else if (this.$root.miniprogram) {
        wx.miniProgram.navigateTo({
          url: `/subPackages/codePage/codePage?communityId=${communityId || ''}`,
        });
      } else {
        const schemeLink = await miniSchemeUrl(
          'wxdb89cfa2bb60f779',
          '/subPackages/codePage/codePage',
          `communityId=${communityId || ''}`,
        );
        window.location.href = schemeLink;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.wx-popup-component {
  position: relative;
  width: 100%;
  min-height: 850px;
  max-height: 928px;
  overflow: hidden;
  background: url('../../../assets/img/productDetail/wx_icon_bg.png') 0 0 no-repeat;
  background-size: 326px 261px;

  .title {
    width: 100%;
    margin-top: 58px;
    color: #333;
    font-weight: blod;
    font-size: 43px;
    line-height: 60px;
    text-align: center;
  }

  .content {
    width: 100%;
    margin-top: 58px;
    color: #333;
    font-weight: blod;
    font-size: 29px;
    line-height: 40px;
    text-align: center;
  }

  .wx-message-img {
    width: 100%;
    height: 326px;
    margin-top: 43px;
    text-align: center;

    img {
      width: 326px;
      height: 326px;
      padding: 20px;
      border: 2px solid #f5f5f5;
      border-radius: 2px;
    }
  }

  .tips {
    width: 100%;
    margin-top: 14px;
    padding: 0 90px;
    text-align: center;
    span {
      display: inline-block;
      color: #a5a5a5;
      font-size: 22px;
      line-height: 31px;
    }
  }

  .footer {
    display: flex;
    justify-content: center;
    width: 100%;

    .footer-btn {
      width: 634px;
      height: 90px;
      margin-top: 43px;
      color: white;
      font-size: 36px;
      line-height: 90px;
      text-align: center;
      background: #ff6c02;
      border-radius: 14px;
    }
  }
}
</style>
